import React from "react";
import {
  CardsSubText,
  HeaderTitle,
  ImgWrapper,
  MainSection,
  MobileWrapper,
  SubText,
  Text,
  Title,
  VisaDiv,
} from "./elements";
import { MainCol, MainContainer, MainRow } from "components/common";
import {
  cards,
  lowFee,
  mastercard,
  mobileprojectfeatureimg1,
  mobileprojectfeatureimg2,
  mobileprojectfeatureimg3,
  mobileprojectfeatureimg4,
  mobileprojectfeatureimg5,
  projectfeatureimg1,
  projectfeatureimg2,
  projectfeatureimg3,
  projectfeatureimg4,
  projectfeatureimg5,
} from "assets";
import { Image } from "react-bootstrap";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { IoIosArrowForward } from "react-icons/io";
import { SiVisa } from "react-icons/si";
type Props = {
  title?: any;
};

const ProjectFeature = () => {
  const data = [
    {
      title: "Crypto Multiple Cross- chain Swap",
      text: `Giving users the ability to create their own wallets and quickly switch between the cheapest offerings for their crypto’s, by the way enterapp.io 
      will provide  their own atomic swap for a very fast and inexpensive swap.`,
      image: projectfeatureimg1,
      mobileimage: mobileprojectfeatureimg1,
      swapbtn: true,
      swapBtnText: "More About Swap",
    },
    {
      title: "Multi NFT Cross-chain Solution",
      text: `We see NFT’s as very promising therefore, enterpp.io will provide Cross-chain swap between the main NFT Marketplace and you will also bbe able  to store, sell or buy your NFT’s with the wallet as well!`,
      image: projectfeatureimg2,
      mobileimage: mobileprojectfeatureimg2,
      swapbtn: true,
      swapBtnText: "More About NFT",
      lowfeeimg: true,
    },
    {
      title: "Multiple Card Solutions",
      text: `enterapo.io will provide everyone personalized Visa & Mastercard payment solutions \n
      enterapp.io will take steps to ensure the user all the necessary benefits of Virtual or Physical care solutions.  \n
      at enterapp.io you will also bo able to load your debit card with your own personal NETS!`,
      image: cards,
      mobileimage: cards,
      cardsData: true,
      swapbtn: true,
      swapBtnText: "More About Cards",
    },
    {
      title: "Seamless Crypto Payments",
      text: `Lorem ipsum dolor sit amet consectetur. Pulvinar curabitur etiamaliquet euismod ultricies. Nisl non sagittis adipiscineu faucibus elementum lacus.Lorem ipsum dolor sit amet consectetur.
        Pulvinar curabitur etiam aliquet euismod ultricies. Nisl non
        sagittis quis adipiscing eu faucibus elementum lacus.`,
      image: projectfeatureimg4,
      mobileimage: mobileprojectfeatureimg4,
    },
    {
      title: "Stake and Earn Rewards",
      text: `Lorem ipsum dolor sit amet consectetur. Pulvinar curabitur etiamaliquet euismod ultricies. Nisl non sagittis adipiscineu faucibus elementum lacus.Lorem ipsum dolor sit amet consectetur.
        Pulvinar curabitur etiam aliquet euismod ultricies. Nisl non
        sagittis quis adipiscing eu faucibus elementum lacus.`,
      image: projectfeatureimg5,
      mobileimage: projectfeatureimg5,
    },
    {
      title: "Staking",
      text: `Lorem ipsum dolor sit amet consectetur. Pulvinar curabitur etiam aliquet euismod ultricies. Nisl non sagittis quis adipiscing eu faucibus elementum lacus.Lorem ipsum dolor sit amet consectetur. Pulvinar curabitur etiam aliquet euismod ultricies. Nisl non sagittis quis adipiscing eu faucibus elementum lacus.`,
      image: projectfeatureimg2,
      mobileimage: mobileprojectfeatureimg2,
    },
  ];

  return (
    <>
      <div
        style={{
          paddingBottom: "2rem",
          marginTop: "-2rem",
          background: "#032B88",
          padding: "2rem 0rem",
        }}
      >
        <AnimationOnScroll animateIn="animate__bounceIn">
          <HeaderTitle>project Main features</HeaderTitle>
          <div className="d-flex justify-content-center align-items-center">
            <SubText>
              <p>
                Get amazing features done with our web3 crypto Neobank{" "}
                <IoIosArrowForward />
              </p>
            </SubText>
          </div>
        </AnimationOnScroll>
      </div>

      <MainSection id="project">
        {data.map((item, index) => (
          <div className={index % 2 === 1 && "color-reverse"}>
            {item.lowfeeimg && <Image src={lowFee} className="low-fee-img" />}
            <MainContainer>
              <MainRow
                style={{ marginTop: "2rem" }}
                className={index % 2 === 1 && "row-reverse"}
              >
                <MainCol lg={6}>
                  <AnimationOnScroll animateIn="animate__fadeInLeft">
                    <Title className={index % 2 === 1 && "title"}>
                      {item.title}
                    </Title>
                    <Text className={index % 2 === 1 && "title"}>
                      {item.text}
                    </Text>
                    {item.cardsData && (
                      <>
                        <VisaDiv>
                          <SiVisa fontSize={56} color="#1732D5" />
                          <Image src={mastercard} />
                        </VisaDiv>
                        <CardsSubText>
                          Reach all your local and worldwide visa and mastercard
                          merchants
                        </CardsSubText>
                      </>
                    )}
                    {item.swapbtn && (
                      <button
                        // className={`swap-btn ${
                        //   index % 2 === 1 && "left-align-btn"
                        // }`}
                        className={`swap-btn ${
                          index % 2 === 1 && "left-align-btn"
                        } ${
                          index === 2 && "center-align-btn" // Add a class for index 3
                        }`}
                      >
                        {item.swapBtnText} <IoIosArrowForward />
                      </button>
                    )}
                  </AnimationOnScroll>
                </MainCol>

                <MainCol lg={6}>
                  <AnimationOnScroll animateIn="animate__fadeInRight">
                    <ImgWrapper>
                      <Image
                        src={item.image}
                        className={`${index === 2 && "margin-top"} ${
                          index === 4 && "reduced-margin-top"
                        } ${index % 2 === 0 && "right-img"}`}
                      />
                    </ImgWrapper>
                  </AnimationOnScroll>
                  <AnimationOnScroll animateIn="animate__fadeInRight">
                    <MobileWrapper>
                      <Image src={item.mobileimage} width={219} height={373} />
                    </MobileWrapper>
                  </AnimationOnScroll>
                </MainCol>
              </MainRow>
            </MainContainer>
          </div>
        ))}

        {/* <MainRow style={{ marginTop: "6rem" }}>
          <MainCol lg={6}>
            <ImgWrapper>
              <img src={projectfeatureimg1} />
            </ImgWrapper>
          </MainCol>

          <MainCol lg={6}>
            <Title title>Explore NFT Marketplace</Title>
            <Text>
              Lorem ipsum dolor sit amet consectetur. Pulvinar
              <br /> curabitur etiam aliquet euismod ultricies. Nisl non
              <br /> sagittis quis adipiscing eu faucibus elementum
              <br /> lacus.Lorem ipsum dolor sit amet consectetur.
              <br />
              Pulvinar curabitur etiam aliquet euismod ultricies.
              <br /> Nisl non sagittis quis adipiscing eu faucibus
              <br /> elementum lacus.
            </Text>
          </MainCol>
        </MainRow> */}
      </MainSection>
    </>
  );
};

export default ProjectFeature;
